//import { useStore } from 'vuex'
import store from "@/store";

export function currentUser() {
  return store.getters.currentUser;
}

export function authenticated() {
  return store.getters.authenticated;
}